import { memo } from "react";
import { Outlet } from "react-router-dom";
import { SupportTicketFiltersProvider } from "./filters/filters-context";
import { SupportProviders } from "./providers/support-providers";
import { SupportTicketsTableProvider } from "./table/support-tickets-table-context";

/**
 * Layout component for Support Helpdesk that provides shared context
 * (collections, feature flags) across all support-v2 routes.
 * This ensures TanStack DB collections persist across navigation.
 *
 * `/support-v2` stays directly accessible even when the team is not assigned
 * to the v2 flag; the flag only controls default navigation and downstream
 * feature-flag-aware behavior.
 */
export const SupportHelpdesk = memo(function SupportHelpdesk() {
  return (
    <SupportTicketFiltersProvider>
      <SupportProviders>
        <SupportTicketsTableProvider>
          <Outlet />
        </SupportTicketsTableProvider>
      </SupportProviders>
    </SupportTicketFiltersProvider>
  );
});
